<app-header title="Ticketing"></app-header>
<div class="mt-5 pt-5">
    <div class="d-flex justify-content-between align-items-center mb-4 ml-2 ml-4">   
        <div (click)="onRedirectToList()">
            <a type="button" 
            class="body-2"
            style="
            cursor: pointer;
            color: #007bff;
            "
            routerLink="/manage/tickets-and-guests/list"
            >
            <i class="fas fa-chevron-left mr-1"></i>
            Back to campaigns list
        </a>
        </div>   
        
    </div>
    <div class="mb-4 mx-4 d-flex justify-content-between">
        <div>
            <div class="align-items-center d-flex justify-content-between">
                <div>
                    <h1 class="p-0 headline-4 mr-2">{{selectedTicketingCampaign?.name}}</h1>
                </div>
               
            </div>
            <span class="body-2 d-flex mb-3" style="color: #676767;">Last Updated On {{updatedOnProperty| date:'MMM dd, yyyy'}}</span>
        </div>

        @if(linkedEvent){
            <div class="no-wrap">
                <div class="event-type--connected green-text body-1 no-wrap">● Connected to {{eventType}} event </div>
                <div class="event-name--connected text-right body-1 no-wrap">{{linkedEvent.name}}</div>
            </div>
        } 
        @if(showConnectToEventButton){
            <div style="align-content: center;" class="no-wrap">
                <button (click)="onConnectToEventClick()" class="btn btn--paybee btn--outline-transparent btn--padding10x15 body-1--weight-medium btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none no-wrap"><i class="black-text fas fa-link mt-0 mr-2"></i>Connect To Event...</button>
            </div>
        }
    </div>

    <div id="ticketingReport">
        <app-header title=""></app-header>
        <div class="mt-5">
           
        
            <div id="ticketingReportNoCampaign" class="text-center no-data-text" style="display:none">
                No Ticketing campaign
            </div>
            <div id="manageTicketCampaignData">
                <ul class="nav nav-tabs md-tabs md-tabs--paybee paybee-modal-header--regular paybee-modal-header--white-important px-4 py-0" role="tablist">
                    <li class="nav-item" id="ticketsTabNavLi">
                        <a class="nav-link" id="ticketsTabNav" data-fragment="ticketsTab" href="#ticketsTab" role="tab" aria-controls="ticketsTab"
                           aria-selected="false">Tickets</a>
                    </li>
                    <li class="nav-item" id="guestsTabNavLi">
                        <a class="nav-link" id="guestsTabNav" data-fragment="guestsTab" href="#guestsTab" role="tab" aria-controls="guestsTab"
                           aria-selected="false">Guests</a>
                    </li>
                    <li class="nav-item" id="guestTableTabNavLi">
                        <a class="nav-link" id="guestTableTabNav" data-fragment="guestTableTab" href="#guestTableTab" role="tab" aria-controls="guestTableTab"
                           aria-selected="false">Tables</a>
                    </li>
                    <li class="nav-item" id="golfHoleTabNavLi">
                        <a class="nav-link" id="golfHoleTabNav" data-fragment="golfHoleTab" href="#golfHoleTab" role="tab" aria-controls="golfHoleTab"
                           aria-selected="false">Golf Holes</a>
                    </li>
                    <li class="nav-item" id="invitesTabNavLi">
                        <a class="nav-link" id="invitesTabNav" data-fragment="invitesTab" href="#invitesTab" role="tab" aria-controls="invitesTab"
                           aria-selected="false">Invitations</a>
                    </li>
                    <li class="nav-item" id="remindersTabNavLi">
                        <a class="nav-link" id="remindersTabNav" data-fragment="remindersTab" href="#remindersTab" role="tab" aria-controls="remindersTab"
                           aria-selected="false">Reminders</a>
                    </li>
                    <li class="nav-item" id="promoCodesTabNavLi">
                        <a class="nav-link" id="promoCodesTabNav" data-fragment="promoCodesTab" href="#promoCodesTab" role="tab" aria-controls="promoCodesTab"
                           aria-selected="false">Promo Codes</a>
                    </li>
                </ul>
                <div class="tab-content pt-5 px-4">
                    <div class="tab-pane fade" id="ticketsTab" role="tabpanel" aria-labelledby="ticketsTabNav">
                        <div class="d-flex align-items-center justify-content-between mb-4">
                            <div class="headline-4 px-3">Tickets</div>
                            <div class="d-flex align-items-center">
                                <button id="basketRaffleDownload" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none"><i class="black-text fas fa-link mt-0 mr-2"></i>Download Allocation</button>
                                <div id="sendReminderToggle">
                                    <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        <span class="mr-2">Reminders</span>
                                        <i class="fas fa-caret-down"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-right">
                                        <li class="dropdown-item body-1" id="ticketAllSendReminder">
                                            <a>Event Reminder...</a>
                                        </li>
                                        <li class="dropdown-item body-1" id="ticketAllSendAddGuestReminder">
                                            <a>Add Guest Reminder...</a>
                                        <div id="ticketAllSendAddGuestReminderError" class="caption red-text">Event date is in the past</div>
                                        </li>
                                        <li class="dropdown-item body-1" id="ticketAllSendSaveCardReminder">
                                            <a>Save Card Reminder...</a>
                                            <div id="ticketAllSendSaveCardReminderError" class="caption red-text">Event date is in the past</div>
                                        </li>
                                        <li class="dropdown-item body-1" id="ticketAllSendRaffleEntityReminder">
                                            <a>Raffle Entry Reminder...</a>
                                        </li>
                                        <!-- <li class="dropdown-item body-1" id="customReminder" (click)="onCustomRemainderClick()"><a>Custom Reminder...</a></li> -->
                                    </ul>
                                </div>
                                <button id="drawWiner" (click)='onDrawModalClick()' class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">Draw Winner</button>
                                <button id="addNewTickets" class="btn btn--paybee btn--purple button waves-effect waves-light">Add Ticket...</button>
                            </div>
                        </div>
                        <div id="ticketsOfTotalCheckedInBlock" class="d-flex align-items-center justify-content-between">
                            <div class="checked-in-card p-3">
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-user mr-2"></i>
                                    <span id="ticketReportCheckedIn" class="subtitle-2--regular"></span>
                                </div>
                            </div>
                        </div>
        
                        <div id="ticketingAndGuestsTicketsStatistic">
                            <div class="row mx-0 mb-2 mt-4 justify-content-center">
                                <div class="d-flex col-12 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-ticket-alt mr-2"></i>
                                        <div class="body-1 text-nowrap">Total Tickets: <span id="ticketingAndGuestsTicketsTotalTicketsStatistic">0</span></div>
                                    </div>
                                </div>
                                <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0" id="ticketingAndGuestsTicketsTotalGuestsBlock">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-user mr-2"></i>
                                        <div class="body-1 text-nowrap">Total Guests: <span id="ticketingAndGuestsTicketsTotalGuestsStatistic">0</span><i class="blue-text far fa-question-circle cursor--pointer ml-2" data-toggle="tooltip" data-placement="top" title="Total Guests should equal Total Tickets. Remind ticket holders to add guests to their tickets by tapping on Remind All and 'Send Add Guest Reminder To All'"></i></div>
                                    </div>
                                </div>
                                <div id="ticketsTotalCheckedInBlock" class="d-flex col-12 col-sm-6 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-user-check mr-2"></i>
                                        <div class="body-1 text-nowrap">Total Checked In: <span id="ticketingAndGuestsTicketsTotalCheckedInStatistic">0</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="table--paybee">
                            <div class='text-center' style="display: none" id="emptyTicketingList">
                                <div class="d-flex flex-column align-items-center my-5">
                                    <img class="mb-3" src="/images/svg/ticket.svg" height="44" width="44">
                                    <div class="headline-5 mb-2">Tickets</div>
                                    <div class="body-1 mb-5">No ticketing transactions yet.</div>
                                </div>
                            </div>
                            <table id ="ticketingList" class="table" cellspacing="0" style="width: 100%;">
                                <thead class="thead-light">
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th class="text-nowrap">First Name</th>
                                        <th class="text-nowrap">Last Name</th>
                                        <th>Option</th>
                                        <th>Count</th>
                                        <th>Guests</th>
                                        <th class="text-nowrap">Checked In</th>
                                        <th>Date</th>
                                        <th>Phone</th>
                                        <th class="text-nowrap">Street Address</th>
                                        <th>
                                            <div class="d-flex align-items-center">
                                                Info
                                                <span data-toggle='popover-hover-table'
                                                    data-trigger='hover'
                                                    data-placement='right'
                                                    title='{{selectedTicketingCampaign?.additionalInfoDesc}}'
                                                    class='ml-1'>
                                                    <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="text-nowrap">
                                            <div class="d-flex align-items-center text-nowrap">
                                                Info Selected
                                                <span data-toggle='popover-hover-table'
                                                    data-trigger='hover'
                                                    data-placement='right'
                                                    title='{{selectedTicketingCampaign?.additionalInfoSelectDesc}}'
                                                    class='ml-1'>
                                                    <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                                                </span>
                                            </div>
                                        </th>
                                        <th class="no-export"></th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="guestsTab" role="tabpanel" aria-labelledby="guestsTabNav">
                        <div id="guestsTabContent" style="display: none;">
                            <div class="row">
                                <div class="col text-center">
                                    <h6 class="font-weight-bold purple-text py-2" id="ticketGuestReportCheckedIn">Checked In: 0/0</h6>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between mb-4">
                                <div class="headline-4 px-3">Guests</div>
                                <div class="d-flex align-items-center">
                                    <div id="managePaddlesToggle" style="display: none;">
                                        <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                                            <i class="fas fa-paper-plane mr-2"></i>
                                            <span class="mr-2">Manage Paddles</span>
                                            <i class="fas fa-caret-down"></i>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-right">
                                            <li class="dropdown-item body-1" id="guestsAssignPaddleAll">Assign Paddles To All...</li>
                                            <li class="dropdown-item body-1" (click)="onClickViewAndDownloadPaddle($event)">View and Download Paddles...</li>
                                            <li class="dropdown-item body-1" id="guestsUnassignPaddles">Unassign Paddles...</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
        
                            <div id="ticketingAndGuestsGuestsStatistic">
                                <div class="row mx-0 mb-2 mt-4 justify-content-center">
                                    <div class="d-flex col-12 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                                        <div class="d-flex align-items-center">
                                            <i class="fas fa-ticket-alt mr-2"></i>
                                            <div class="body-1 text-nowrap">Total Tickets: <span id="ticketingAndGuestsGuestsTotalTicketsStatistic">0</span></div>
                                        </div>
                                    </div>
                                    <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                                        <div class="d-flex align-items-center">
                                            <i class="fas fa-user mr-2"></i>
                                            <div class="body-1 text-nowrap">Total Guests: <span id="ticketingAndGuestsGuestsTotalGuestsStatistic">0</span><i class="blue-text far fa-question-circle cursor--pointer ml-2" data-toggle="tooltip" data-placement="top" title="Total Guests should equal Total Tickets. Remind ticket holders to add guests to their tickets by tapping on Remind All and 'Send Add Guest Reminder To All'"></i></div>
                                        </div>
                                    </div>
                                    <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                                        <div class="d-flex align-items-center">
                                            <i class="fas fa-user-check mr-2"></i>
                                            <div class="body-1 text-nowrap">Total Checked In: <span id="ticketingAndGuestsGuestsTotalCheckedInStatistic">0</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
        
                            <div class="table--paybee">
                                <div class='text-center' style="display: none" id="emptyGuestList">
                                    <div class="d-flex flex-column align-items-center my-5">
                                        <img class="mb-3" src="/images/svg/users.svg" height="44" width="44">
                                        <div class="headline-5 mb-2">Guests</div>
                                        <div class="body-1 mb-5">No guests added yet.</div>
                                    </div>
                                </div>
                                <table id ="guestList" class="table" cellspacing="0" style="width: 100%;">
                                    <thead class="thead-light">
                                    <tr id="guestListColumns">
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                        <div id="guestsTabInstruction">
                            <div class="d-flex flex-column align-items-center my-5">
                                <img class="mb-3" src="/images/svg/users.svg" height="44" width="44" />
                                <div class="headline-5 mb-2">Guests</div>
                                <div class="body-1 mb-5">This functionality is currently disabled.</div>
                                <div class="instruction p-4">
                                    <div class="body-2 mb-2">Instruction to enable Guests:</div>
                                    <div class="body-2">1. Please turn on "Collect Guest Information" in Ticketing Campaign</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="guestTableTab" role="tabpanel" aria-labelledby="guestsTableTabNav">
                        <div id="guestTableTabContent" style="display: none;">
                            <div class="d-flex align-items-center justify-content-between mb-4">
                                <div class="headline-4 px-3">Tables</div>
    
                                <div class="d-flex align-items-center">
                                    <button class="btn btn--paybee btn--purple button waves-effect waves-light" (click)="onClickImport()">Bulk Import</button>
                                    <button id="addNewTablesReport" class="btn btn--paybee btn--purple button waves-effect waves-light ml-2">Add Tables...</button>
                                </div>
                            </div>
                            <div class="table--paybee">
                                <div class='text-center' style="display: none" id="emptyGuestTableList">
                                    <div class="d-flex flex-column align-items-center my-5">
                                        <img class="mb-3" src="/images/svg/table.svg" height="44" width="44">
                                        <div class="headline-5 mb-2">Tables</div>
                                        <div class="body-1 mb-5">No tables added yet.</div>
                                    </div>
                                </div>
                                <table class="table" id="guestTableList" cellspacing="0" style="width: 100%;">
                                    <thead class="thead-light">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Seats</th>
                                        <th scope="col">Guest Assigned</th>
                                        <th scope="col">Category</th>
                                        <th scope="col">Table Name</th>
                                        <th scope="col">
                                            Assigned Seating Within Table
                                            <i data-toggle="tooltip" data-placement="top" title="" class="blue-text far fa-question-circle cursor--pointer ml-1" data-original-title="YES indicates that you are assigning guests to specific tables and specific seats within the table. NO indicates that seating within the table is not important. For eg., a guest could be assigned Seat A in Table 1."></i>
                                        </th>
                                        <th scope="col"></th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                        <div id="guestTableTabInstruction">
                            <div class="d-flex flex-column align-items-center my-5">
                                <img class="mb-3" src="/images/svg/table.svg" height="44" width="44" />
                                <div class="headline-5 mb-2">Tables</div>
                                <div class="body-1 mb-5">This functionality is currently disabled.</div>
                                <div class="instruction px-4 pt-4 pb-2">
                                    <div class="body-2 mb-2">Instruction to enable Tables:</div>
                                    <div class="body-2">1. Please connect Ticketing Campaign to In-Person Event</div>
                                    <div class="body-2">2. Please enable "Guest will have assigned tables"</div>
                                    @if(typeData?.isTicketForInPersonEvent && typeData?.linkedEventId && linkedEvent?.tableRequired === false){
                                        <div class="d-flex justify-content-center mt-4">
                                            <button 
                                            (click)="onEnableTableAssignment()"
                                            class="btn btn-sm modal-confirm-button waves-effect waves-light"
                                            >
                                                Enable table assignment
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="golfHoleTab" role="tabpanel" aria-labelledby="guestsTabNav">
                        <div id="golfHoleTabContent" style="display: none;">
                            <div class="d-flex align-items-center justify-content-between mb-4">
                                <div class="headline-4 px-3">Golf Holes</div>
    
                                <div class="d-flex align-items-center">
                                    <button (click)="onClickViewAndDownloadPaddle($event, 'golfCartSignPaddlesDiv')" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        <span class="mr-2">Download Cart Signs</span>
                                    </button>
                                    <button id="addNewGolfHole" class="btn btn--paybee btn--purple button waves-effect waves-light">Add Golf Holes...</button>
                                </div>
                            </div>
                            <div class="table--paybee">
                                <div class='text-center' style="display: none" id="emptyGolfHoleList">
                                    <div class="d-flex flex-column align-items-center my-5">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="44px" height="44px" viewBox="0 0 274.953 274.952" xml:space="preserve">
                                            <g>
                                                <g>
                                                    <path d="M208.693,130.098v35.022c3.981,2.949,6.371,6.716,6.371,10.827c0,9.455-12.662,17.123-28.278,17.123    s-28.277-7.668-28.277-17.123c0-8.046,9.161-14.767,21.506-16.615v-40.456c-17.282-4.879-37.09-7.652-58.147-7.652    C54.563,111.224,0,139.53,0,174.444c0,34.924,54.563,63.225,121.867,63.225s121.867-28.306,121.867-63.225    C243.743,157.162,230.363,141.504,208.693,130.098z"/>
                                                    <path d="M256.96,57.942c-9.549-9.306-16.442-16.029-27.447-19.14c-23.457-6.611-39.265,10.457-39.927,11.187    c-1.531,1.683-2.423,4.1-2.46,6.648l-1.615,122.478c-0.079,4.975,3.071,9.059,7.034,9.115c3.962,0.064,7.225-3.926,7.304-8.9    l0.873-72.881c25.416,5.855,66.291,2.18,73.18-17.201c1.246-3.493,3.136-12.545-6.156-21.051    C263.574,64.374,260.068,60.962,256.96,57.942z"/>
                                                </g>
                                            </g>
                                        </svg>
                                        <div class="headline-5 mb-2">Golf Holes</div>
                                        <div class="body-1 mb-5">No golf holes added yet.</div>
                                    </div>
                                </div>
                                <table class="table" id="golfHoleList" cellspacing="0" style="width: 100%;">
                                    <thead class="thead-light">
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Group Size</th>
                                        <th scope="col">Guest Assigned</th>
                                        <th scope="col">Group Letter</th>
                                        <th scope="col">Hole Name</th>
                                        <th scope="col"></th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="invitesTab" role="tabpanel" aria-labelledby="invitesTabNav">
                        <div class="d-flex align-items-center justify-content-between mb-4">
                            <div class="headline-4 px-3">Invitations</div>
                            <div class="d-flex align-items-center">
                                <button id="remindPendingInvitees"  class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                                    <i class="fas fa-paper-plane mr-2"></i>
                                    <span class="mr-2">Invitation Reminders... </span>
                                </button>
                                <button id="sendNewInvitees" class="btn btn--paybee btn--purple button waves-effect waves-light">Invite...</button>
                            </div>
                        </div>
                        <div id="invitationsStatistic">
                            <div class="row mx-0 mb-4">
                                <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-2 justify-content-center mb-2 mb-xl-0 offset-xl-1">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        <div class="body-1 text-nowrap"><span id="sent">0</span> Sent</div>
                                    </div>
                                </div>
                                <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-2 justify-content-center mb-2 mb-xl-0">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-eye mr-2"></i>
                                        <div class="body-1 text-nowrap"><span id="opened">0</span> Opened</div>
                                    </div>
                                </div>
                                <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-2 justify-content-center mb-2 mb-xl-0">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-check-circle mr-2 green-text"></i>
                                        <div class="body-1 text-nowrap"><span id="accepted">0</span> Accepted</div>
                                    </div>
                                </div>
                                <div class="d-flex col-12 col-sm-6 col-md-6 col-xl-2 justify-content-center mb-2 mb-xl-0">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-ban mr-2 red-text"></i>
                                        <div class="body-1 text-nowrap"><span id="declined">0</span> Declined</div>
                                    </div>
                                </div>
                                <div class="d-flex col-12 col-sm-12 col-md-6 col-xl-2 justify-content-center mb-2 mb-xl-0">
                                    <div class="d-flex align-items-center">
                                        <i class="fas fa-question mr-2 red-text"></i>
                                        <div class="body-1 text-nowrap"><span id="bounced">0</span> Bounced</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="table--paybee">
                            <div class='text-center' style="display: none" id="emptyInviteList">
                                <div class="d-flex flex-column align-items-center my-5">
                                    <img class="mb-3" src="/images/svg/paperplane.svg" height="44" width="44">
                                    <div class="headline-5 mb-2">Invitations</div>
                                    <div class="body-1 mb-5">No invitations added yet.</div>
                                </div>
                            </div>
                            <table id="inviteList" class="table" cellspacing="0" style="width: 100%;">
                                <thead class="thead-light">
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Option</th>
                                    <th>Count</th>
                                    <th>Created</th>
                                    <th>Updated</th>
                                    <th style="white-space: nowrap;">Last Reminded</th>
                                    <th>Reminders</th>
                                    <th>Status</th>
                                    <th class="no-export"></th>
                                </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="remindersTab" data-page="scheduleReminder" role="tabpanel" aria-labelledby="remindersTabNav">
                        <div class="accordion md-accordion" id="scheduleReminderAccordion" style="border:none !important;" role="tablist" aria-multiselectable="true">
    
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <div class="headline-4 px-3">Reminders</div>
                                <div class="d-flex align-items-end flex-column">
                                    <div class="d-flex">
                                        <div id="sendReminderToggle" class="mb-2">
                                            <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                                                <i class="fas fa-paper-plane mr-2"></i>
                                                <span class="mr-2">Send now</span>
                                                <i class="fas fa-caret-down"></i>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-right">
                                                <li class="dropdown-item body-1" id="ticketAllSendReminderRemTab"><a>Event Reminder...</a></li>
                                                <li class="dropdown-item body-1" id="ticketAllSendAddGuestReminderRemTab">
                                                    <a>Add Guest Reminder...</a>
                                                    <div id="ticketAllSendAddGuestReminderRemTabError" class="caption red-text">Event date is in the past</div>
                                                </li>
                                                <li class="dropdown-item body-1" id="ticketAllSendSaveCardReminderRemTab">
                                                    <a>Save Card Reminder...</a>
                                                    <div id="ticketAllSendSaveCardReminderRemTabError" class="caption red-text">Event date is in the past</div>
                                                </li>
                                                <li class="dropdown-item body-1" id="remindPendingInviteesRemindersTab"><a>Invitation Reminders...</a></li>
                                                <li class="dropdown-item body-1" id="ticketAllSendRaffleEntityReminderRemTab"><a>Raffle Entry Reminder...</a></li>
                                            </ul>
                                        </div>
                                        <div  class="mb-2">
                                            <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 shadow-none">
                                                <i class="fas fa-paper-plane mr-2"></i>
                                                <span class="mr-2">Schedule</span>
                                                <i class="fas fa-caret-down"></i>
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-right">
                                                <li data-id="scheduleCustomReminder_1" data-task-type="1" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                                    <a>Event Reminder...</a>
                                                </li>
                                                <li data-id="scheduleCustomReminder_2" data-task-type="2" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                                    <a>Add Guest Reminder...</a>
                                                    <div data-id="scheduleCustomReminder_2_error" class="caption red-text">Event date is in the past</div>
                                                </li>
                                                <li data-id="scheduleCustomReminder_9" data-task-type="9" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                                    <a>Invite Reminder...</a>
                                                    <div data-id="scheduleCustomReminder_9_error" class="caption red-text">Event date is in the past</div>
                                                </li>
                                                @if (!selectedTicketingCampaign?.campaignTypeData?.linkedVirtualEventId) {
                                                    <li data-id="scheduleCustomReminder_13" data-task-type="13" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                                        <a>Save Card Reminder...</a>
                                                        <div data-id="scheduleCustomReminder_13_error" class="caption red-text">Event date is in the past</div>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                    <div id="eventDateTime" class="body-1"></div>
                                </div>
                            </div>
    
                            <div class="card" data-section="suggestedReminderCard">
                                <div class="card-header px-1" role="tab" id="suggestedReminderHeading" data-section="suggestedReminderHeading">
                                    <a id="suggestedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#suggestedReminderCollapse" aria-expanded="false" aria-controls="suggestedReminderCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Suggested</span>
                                    </a>
                                </div>
    
                                <div id="suggestedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="suggestedReminderHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="recommendationListContainer" data-section="suggestedReminderListContainer"></div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card" data-section="scheduledReminderCard">
                                <div class="card-header px-1" role="tab" id="scheduledReminderHeading" data-section="scheduledReminderHeading">
                                    <a id="scheduledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#scheduledReminderCollapse" aria-expanded="false" aria-controls="scheduledReminderCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Scheduled</span>
                                    </a>
                                </div>
    
                                <div id="scheduledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="scheduledReminderHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="scheduledListContainer" data-section='scheduledReminderListContainer'></div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card" data-section="completedReminderCard">
                                <div class="card-header px-1" role="tab" id="completedReminderHeading" data-section="completedReminderHeading">
                                    <a id="completedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#completedReminderCollapse" aria-expanded="false" aria-controls="completedReminderCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Completed</span>
                                    </a>
                                </div>
    
                                <div id="completedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="completedReminderHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="completedListContainer" data-section='completedReminderListContainer'></div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card" data-section="cancelledReminderCard">
                                <div class="card-header px-1" role="tab" id="cancelledReminderHeading" data-section="cancelledReminderHeading">
                                    <a id="cancelledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#cancelledReminderCollapse" aria-expanded="false" aria-controls="cancelledReminderCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Cancelled</span>
                                    </a>
                                </div>
    
                                <div id="cancelledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="cancelledReminderHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="cancelledListContainer" data-section='cancelledReminderListContainer'></div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="tab-pane fade" id="promoCodesTab" data-page="promoCodes" role="tabpanel" aria-labelledby="promoCodesTabNav">
                        <div class="accordion md-accordion" style="border:none !important;" role="tablist" aria-multiselectable="true">
                            <div class="d-flex align-items-center justify-content-between mb-4">
                                <div class="headline-4 px-3">Promo Codes</div>
                                <div class="d-flex align-items-center">
                                    <button id="createPromoCode" class="btn btn--paybee btn--purple button waves-effect waves-light">Create Promo Code...</button>
                                </div>
                            </div>
    
                            <div class="card" id="activePromoCodeCard" data-section="activePromoCodeCard">
                                <div class="card-header px-1" role="tab" id="activePromoCodeHeading" data-section="activePromoCodeHeading">
                                    <a id="activePromoCodeHeadingLink" class="accordion-button--scheduller" data-toggle="collapse" href="#activePromoCodeCollapse" aria-expanded="true" aria-controls="activePromoCodeCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Active</span>
                                    </a>
                                </div>
    
                                <div id="activePromoCodeCollapse" class="collapse show" role="tabpanel" aria-labelledby="activePromoCodeHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="activePromoCodeContainer" data-section="activePromoCodeContainer"></div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="card" id="inactivePromoCodeCard" data-section="inactivePromoCodeCard">
                                <div class="card-header px-1" role="tab" id="inactivePromoCodeHeading" data-section="inactivePromoCodeHeading">
                                    <a id="inactivePromoCodeHeadingLink" class="accordion-button--scheduller" data-toggle="collapse" href="#inactivePromoCodeCollapse" aria-expanded="true" aria-controls="inactivePromoCodeCollapse">
                                        <span class="headline-6 black-text pl-5 mb-2">Inactive</span>
                                    </a>
                                </div>
    
                                <div id="inactivePromoCodeCollapse" class="collapse show" role="tabpanel" aria-labelledby="inactivePromoCodeHeading">
                                    <div class="card-body pt-0 px-0">
                                        <div class="col-12 col-xl-10" id="inactivePromoCodeContainer" data-section="inactivePromoCodeContainer"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </div>